// src/components/Layout/ProtectedRoute.jsx
import React, { useContext, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ requireQuestionnaire = false }) => {
    const { isLoggedIn, token, handleSessionExpired, user } = useContext(AuthContext);
    const location = useLocation();

    // Function to check if token is expired
    const isTokenExpired = () => {
        if (!token) return true;
        
        try {
            const decodedToken = jwtDecode(token);
            const currentTime = Date.now() / 1000; // Convert to seconds
            
            if (decodedToken.exp && decodedToken.exp < currentTime) {
                return true;
            }
            return false;
        } catch (e) {
            return true; // Consider invalid tokens as expired
        }
    };

    // Check token expiration on mount and when location changes
    useEffect(() => {
        if (token && isTokenExpired()) {
            handleSessionExpired();
        }
    }, [token, handleSessionExpired, location]);

    // If not logged in or token is expired, redirect to auth page
    if (!isLoggedIn || isTokenExpired()) {
        // Store the current location for redirection after login
        const currentPath = location.pathname + location.search;
        if (currentPath && !currentPath.includes('/auth')) {
            localStorage.setItem('returnUrl', currentPath);
        }
        
        return <Navigate to="/auth" replace />;
    }

    // If questionnaire required and not complete, redirect to onboarding
    if (requireQuestionnaire && user && !user.questionnaire_complete && location.pathname !== '/onboarding') {
        return <Navigate to="/onboarding" replace />;
    }

    // If authenticated, render the nested routes
    return <Outlet />;
};

export default ProtectedRoute;